import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Facebook, Instagram, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative min-h-[680px] overflow-hidden pt-[88px] text-white sm:min-h-[760px]">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://static.wixstatic.com/media/86662f_d40a8765aab94d9f92f4d82613945c45~mv2.jpg/v1/fill/w_1960,h_1000,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/86662f_d40a8765aab94d9f92f4d82613945c45~mv2.jpg')",
        }}
      />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(12,25,47,0.90)_0%,rgba(12,25,47,0.72)_47%,rgba(12,25,47,0.18)_100%)]" />
      <div className="absolute inset-x-0 bottom-0 h-36 bg-gradient-to-t from-[#0c192f]/60 to-transparent" />

      <div className="page-container relative flex min-h-[592px] items-end pb-10 pt-10 sm:min-h-[672px] sm:items-center sm:pb-20 sm:pt-16">
        <div className="max-w-3xl">
          <div className="mb-5 flex items-center gap-2 text-xs font-bold uppercase text-[#f6b8c3]">
            <MapPin className="h-4 w-4" />
            Jacksonville, Florida
          </div>
          <h1 className="max-w-3xl text-4xl font-extrabold leading-[1.04] sm:text-6xl lg:text-7xl">
            Japanese Association of Jacksonville
          </h1>
          <p className="font-japanese mt-3 text-xl font-semibold text-[#f4d5da] sm:text-2xl">
            ジャクソンビル日本人会
          </p>
          <p className="mt-6 max-w-2xl text-sm leading-6 text-white/85 sm:mt-7 sm:text-lg sm:leading-7">
            {t('hero.description')}
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/membership" className="btn-primary bg-[#d95f75] hover:bg-[#c44f66]">
              Join Our Community
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/mission-statement" className="btn-secondary border-white/40 bg-white/10 text-white backdrop-blur-sm hover:border-white hover:text-white">
              Our Mission
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 right-0 hidden items-center gap-2 border-l border-t border-white/20 bg-[#0c192f]/65 px-6 py-4 backdrop-blur-md sm:flex">
        <span className="mr-2 text-xs font-bold uppercase text-white/65">Follow JAJ</span>
        <a href="https://www.facebook.com/jaj.florida" target="_blank" rel="noopener noreferrer" className="flex h-9 w-9 items-center justify-center bg-white text-[#2457a7] transition hover:bg-[#f4d5da]" aria-label="Facebook">
          <Facebook className="h-4 w-4" />
        </a>
        <a href="https://www.instagram.com/japaneseassociation" target="_blank" rel="noopener noreferrer" className="flex h-9 w-9 items-center justify-center bg-white text-[#d95f75] transition hover:bg-[#f4d5da]" aria-label="Instagram">
          <Instagram className="h-4 w-4" />
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
